import { useActionState } from "react"
import {
  Button,
  Form,
  ProgressCircle,
  Text,
  TextField,
  View,
  Link
} from "@/components/wrappers/Spectrum/SpectrumWrapper.tsx"
import { UiPreferences } from "@/components/app/UiPreferences.tsx"
import { LocalStorage } from "@/helpers/LocalStorage.ts"
import { Navigate } from "react-router"
import { appFetch, ErrorResponse } from "@/helpers/fetch.ts"

type LoginResponse = {
  token: string
  userId: number
  username: string
  defaultUnit: string
  roleId: string
}

type LoginRequest = {
  username: string
  password: string
  clientIp: string
  userAgent: string
  timeStamp: string
  clientId: string
  clientVersion: string
}

async function loginAction(_: LoginResponse | string, formData: FormData) {
  const username = formData.get("username")
  const password = formData.get("password")
  if (!(username && password)) {
    return "Invalid username or password"
  }

  const body: LoginRequest = {
    username: username as string,
    password: password as string,
    userAgent: "Hello",
    clientId: "clientId",
    clientIp: "clientIp",
    clientVersion: "clientVersion",
    timeStamp: "Time",
  }

  const response = await appFetch<LoginResponse | ErrorResponse, LoginRequest>(
    "login",
    "POST",
    body
  ).then((response) => {
    console.log(response)
    return response
  })

  const data = response as LoginResponse
  const error = response as ErrorResponse
  if (data.token) {
    LocalStorage.setSecret("token", data.token)
    LocalStorage.setSecret("username", data.username)
    LocalStorage.setSecret("roleId", data.roleId)
    LocalStorage.setSecret("userId", data.userId)
    LocalStorage.setSecret("unit", data.defaultUnit)
    return "Logging in..."
  } else {
    return error.message
  }
}

export function LoginForm() {
  const [loginState, formAction, pending] = useActionState<string, FormData>(
    loginAction,
    ""
  )
  if (LocalStorage.getSecret("token")) {
    return <Navigate to="/dashboard" />
  }

  return (
    <View
      borderWidth="thin"
      borderColor="dark"
      borderRadius="regular"
      padding="size-250"
      maxWidth="400px"
      UNSAFE_style={{ backdropFilter: "blur(6px)" }}
    >
      <div className={"p-5"}>
        <Form action={formAction}>
          <div className={"flex w-full flex-row justify-between"}>
            <Text alignSelf={"center"}>Login</Text>
            <UiPreferences />
          </div>

          <TextField
            label="Username"
            name="username"
            autoComplete="username"
            type="text"
            isRequired
          />
          <TextField
            label="Password"
            name="password"
            type="password"
            autoComplete="current-password"
            isRequired
          />
          {loginState ? <p>{loginState}</p> : <></>}
          <Button variant={"accent"} type="submit" isDisabled={pending}>
            {!pending && "Submit"}
            {pending && (
              <ProgressCircle size="S" aria-label="Loading…" isIndeterminate />
            )}
          </Button>
        </Form>
        <Link href="/login/resetPassword" UNSAFE_className={"my-24"} >
          Forgot password?
        </Link>
      </div>
    </View>
  )
}
